import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between gap-2" }
const _hoisted_2 = { class: "text-xs" }

import { DatePicker } from '@/components/ui/form';
    import { ref } from 'vue';
    import { toast } from 'vue-sonner';
    import { useDateFormat } from '@/composables/useDateFormat';
    import { useI18n } from 'vue-i18n';
    import { useUpdateDatatableRow } from '@/composables/useUpdateDatatableRow';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import type { DashboardTableData } from '@/types';
    import type { Row } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableDateSelect',
  props: {
    row: {},
    reportingPeriod: {},
    selectedGrouping: {},
    columnId: {}
  },
  setup(__props: any) {

    const { formatDMYFromIso } = useDateFormat();

    const { updateDataTableRow } = useUpdateDatatableRow();

    const props = __props;

    const { t } = useI18n();

    const currentValue = ref(props.row.original[props.columnId] as string);

    const initialized = ref(false);

    const handleDateChange = async (newValue: string) => {
        if (!initialized.value) return;

        const previousValue = currentValue.value;

        try {
            if (newValue === currentValue.value) return;

            currentValue.value = newValue;

            await axios.post(
                route('v2.dashboard.pbc-deadline.update', { company: props.row.original.id }),
                {
                    reporting_period: props.reportingPeriod,
                    deadline: newValue,
                },
            );

            updateDataTableRow(
                [
                    QueryKey.EMPLOYEE_DASHBOARD,
                    {
                        selectedGrouping: props.selectedGrouping,
                        reportingPeriod: props.reportingPeriod,
                    },
                ],
                props.row.index,
                props.columnId,
                newValue,
            );
        } catch (error) {
            currentValue.value = previousValue;
            console.error('Failed to update status:', error);
            toast.error(t('dashboards.status_update_failed'));
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(currentValue.value ? _unref(formatDMYFromIso)(currentValue.value) : ''), 1),
    _createVNode(_unref(DatePicker), {
      "model-value": currentValue.value,
      "onUpdate:modelValue": handleDateChange,
      class: "ml-auto border-none px-0",
      "show-input": false,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (initialized.value = true))
    }, null, 8, ["model-value"])
  ]))
}
}

})